export enum SeasonalityMode {
    MULTIPLICATIVE = 'multiplicative',
    ADDITIVE = 'additive'
}

export enum TrendMode {
    LINEAR = 'linear',
    LOGISTIC = 'logistic',
    FLAT = 'flat'
}

export enum ForecastModel {
    ARIMA = 'arima',
    PROPHET = 'prophet',
}

export type ForecastParameters = {
    model?: ForecastModel;

    growth?: TrendMode;
    changepoint_prior_scale?: number;


    seasonality_mode?: SeasonalityMode;
    seasonality_prior_scale?: number;

    search_term_regressor?: string;
    search_term_regressor_prior_scale?: number;
    search_term_regressor_mode?: SeasonalityMode;
    search_term_regressor_standardize?: boolean;
}